import { render, staticRenderFns } from "./AppointmentByRoomReport.vue?vue&type=template&id=4eb3d56f"
import script from "./AppointmentByRoomReport.vue?vue&type=script&lang=js"
export * from "./AppointmentByRoomReport.vue?vue&type=script&lang=js"
import style0 from "./AppointmentByRoomReport.vue?vue&type=style&index=0&id=4eb3d56f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports